<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="任务类型" prop="type">
                <el-select v-model="queryCondition.type" clearable filterable placeholder="请选择" style="width:100%">
                  <el-option :key="index" v-for="(item, index) in typeLists" :label="item" :value="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="任务名称" prop="name">
                <el-input v-model="queryCondition.name" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建日期从" prop="createDateFrom">
                <el-date-picker style="width: 100%" v-model="queryCondition.createDateFrom" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建日期至" prop="createDateTo">
                <el-date-picker style="width: 100%" v-model="queryCondition.createDateTo" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-table :data="tableData" border max-height="650" highlight-current-row>
        <el-table-column show-overflow-tooltip sortable prop="flowName" label="任务流程" min-width="130"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="typeName" label="类型" min-width="160"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="name" label="任务名称" min-width="140"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="createDate" label="待办任务创建时间" min-width="100" align="center"></el-table-column>
        <el-table-column show-overflow-tooltip sortable label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button size="mini" @click="audit(scope.row.flowName, scope.row)" type="primary">处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import taskApi from "../../../api/myTask";
import commonFunction from "@/utils/dataTableUtils";
import prot3p from "@/api/rmcProtein/prot3p";

export default {
  name: "",
  components: {},
  data() {
    return {
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        createDateFrom: "",
        createDateTo: "",
        name: "",
        type: "",
      },
      tableData: [],
      typeLists: [],
      totalCount: 0,
      labelPosition: "right",
    };
  },
  created() {
    this.queryData();
    this.getQspiToDoType();
  },
  methods: {
    queryData() {
      if (
        this.queryCondition.createDateFrom === null ||
        this.queryCondition.createDateFrom === undefined
      ) {
        this.queryCondition.createDateFrom = "";
      }
      if (
        this.queryCondition.createDateTo === null ||
        this.queryCondition.createDateTo === undefined
      ) {
        this.queryCondition.createDateTo = "";
      }
      if (
        this.queryCondition.name === null ||
        this.queryCondition.name === undefined
      ) {
        this.queryCondition.name = "";
      }
      if (
        this.queryCondition.type === null ||
        this.queryCondition.type === undefined
      ) {
        this.queryCondition.type = "";
      }
      taskApi
        .getNutritionToDoLists(
          this.queryCondition.createDateFrom,
          this.queryCondition.createDateTo,
          this.queryCondition.name,
          this.queryCondition.type,
          this.queryCondition.pageNum,
          this.queryCondition.pageSize
        )
        .then((res) => {
          this.tableData = res.resultData;
          this.totalCount = res.totalCount;
        });
    },
    getQspiToDoType() {
      taskApi.getNutritionToDoType().then((res) => {
        console.log("res", res);
        this.typeLists = res;
      });
    },
    audit(flowName, row) {
      console.log("flowName", flowName);
      console.log("rowrowrow", row);
      if (row.type === "NUTRITION_CQS_CONFIRM") {
        this.$router.push({
          path: "/nutritionInspect",
          query: {
            CATEGORY2_CODE: row.params.CATEGORY2_CODE,
            STATUS: row.params.STATUS,
          }
        })
      } else if (row.type === "NUTRITION_OWNER_REVIEW") {
        this.$router.push({
          path: "/nutritionReport",
          // query: {
          //   flag: "NUTRITION_OWNER_REVIEW"
          // }
        })
      } else if (row.type === "NUTRITION_LAB_COMMENTS") {
        taskApi.closeNutritionTodo(row.ttQspiTodoId).then((res) => {
          console.log("res", res);
          if (res.code == '200') {
            this.$router.push({
              path: "/nutritionReport",
              query: {
                flag: "NUTRITION_LAB_COMMENTS"
              }
            })
          }
        });
      } else {
        this.$router.push({
          path: "/nutritionInspect",
          query: {
            STATUS: row.params.STATUS,
          }
        })
      }
    },
    onReset() {
      this.$refs["queryCondition"].resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        createDateFrom: "",
        createDateTo: "",
        name: "",
        type: "",
      };
      this.queryData();
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val;
      this.queryData();
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val;
      this.queryData();
    },
  },
  extends: commonFunction,
};
</script>
<style scoped></style>
